module.exports = __webpack_public_path__ + "static/img/xinbi@2x.134cfc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new4/xinbi@2x.png
// module id = iR2i
// module chunks = 5